import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useParams, useSearchParams } from "react-router-dom";
import Spinner from "../../components/Reuseable/Spinner";
const CategoryDetailComponent = loadable(
  () => import("../../components/Category/CategoryDetail")
);

type Props = {};

const CategoryDetail = (props: Props) => {
  const { id } = useParams();
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const { data: productData, isPending: productLoading } = useGetHook({
    queryKey: ["product", pageSize, offset, searchQuery, id],
    url: `${APIS.PRODUCT}`,
    params: {
      limit: pageSize,
      available_quantity__gte: 1,
      category: id,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });

  return (
    <>
      <CategoryDetailComponent
        productData={productData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
        productLoading={productLoading}
      />
    </>
  );
};

export default CategoryDetail;
